import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import { JOURNAL_ENTRY, JOURNAL_ENTRY_PAGES } from './constants';
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import {TextField } from '@material-ui/core';
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MenuIcon from '@mui/icons-material/Menu';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import { HourglassEmptyTwoTone } from '@material-ui/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SaveIcon from '@material-ui/icons/Save';
import Divider from '@material-ui/core/Divider';

class EditJournalEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            templates: this.props.entries || [],
            anchorEl: null,
            activeIndex: null,
            draggedIndex: null,
            journalEntryDate: null,
            journalEntryDescription: '',
            totalDebit: 0.00,
            totalCredit: 0.00,
            isSave: false,
            notes:'',
            journalEntryId: null,
            deletedEntry: []
        };
    }

    componentDidMount() {

     const {selectedYear} = this.props;
        const date = selectedYear === new Date().getFullYear().toString()
            ? new Date(Date.now())
            : new Date(`${selectedYear}-01-02`);
      this.setState({journalEntryDate: date})


        if (this.props.journalEntryEditing.journalEntries && this.props.journalEntryEditing.journalEntries.length > 0) {
            this.setState({
                templates: [...this.props.journalEntryEditing.journalEntries],
              journalEntryDate: this.props.journalEntryEditing.journalEntryDate,
              journalEntryDescription: this.props.journalEntryEditing.journalEntryDescription,
              notes: this.props.journalEntryEditing.notes,
              journalEntryId: this.props.journalEntryEditing.journalEntryId
            });
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.templates !== this.state.templates) {
            this.calculateTotals();
        }
    }

  calculateTotals = () => {
    const { templates } = this.state;

    let totalDebit = 0;
    let totalCredit = 0;
    let isSave = true;

    for (const template of templates) {

      const debit = this.parseNumber(template.debit || 0);
      const credit = this.parseNumber(template.credit || 0);

      totalDebit += debit;
      totalCredit += credit;

      if (!template.description || (!template.debit && !template.credit)) {
        isSave = false;
      }
    }


    this.setState({
      totalDebit: parseFloat(totalDebit.toFixed(2)),
      totalCredit: parseFloat(totalCredit.toFixed(2)),
      isSave: isSave && totalDebit === totalCredit
    });
  }

    onDragStart = (index) => {
        this.setState({draggedIndex: index});
    };


    onDragOver = (index) => {
        const {draggedIndex, templates} = this.state;
        if (draggedIndex === index) return;

        const updatedTemplates = [...templates];
        const [draggedItem] = updatedTemplates.splice(draggedIndex, 1);
        updatedTemplates.splice(index, 0, draggedItem);

        this.setState({
            templates: updatedTemplates,
            draggedIndex: index,
        });
    }


    onDragEnd = () => {
        this.setState({draggedIndex: null})
    }

    getContextualMenuItems = () => {
        const menuItems = [];
        menuItems.push(


          {
            title: 'Back',
            icon: <KeyboardBackspaceIcon />,
            onClick: () => {
                this.props.setCurrentPage(JOURNAL_ENTRY_PAGES.TABLE, {})
            },
          },
          {
            title: 'Save',
            icon: <SaveIcon />,
            disabled: this.isSaveDisabled(),
            onClick: () => {

              const data = {
                deletedEntry: this.state.deletedEntry,
                year: this.props.selectedYear,
                currency: this.props.selectedCurrency,
                journalEntries: this.state.templates,
                notes: this.state.notes,
                journalEntryDate: this.state.journalEntryDate,
                journalEntryDescription: this.state.journalEntryDescription,
                amount: this.state.totalCredit,
                journalEntryId: this.state.journalEntryId
              }

              this.props.saveJournalEntry(data, ()=>{
                this.props.listJournalEntries({
                  currency: this.props.selectedCurrency,
                  year: this.props.selectedYear})
              })
              this.props.setCurrentPage(JOURNAL_ENTRY_PAGES.TABLE, {})
            },
          }

          );


        //loading indicator
        if (this.props.loadingData) {
            menuItems.push({
                title: "Loading data...",
                icon: <HourglassEmptyTwoTone />,
                onClick: () => null,
                disabled: true
            })
        }


        // Combine back button with menu items
        return [...menuItems];
    };


  isSaveDisabled = () => {
    const { templates, journalEntryDate, journalEntryDescription } = this.state;
    if (templates.length === 0) return true
    // Check if any template is incomplete
    const hasInvalidTemplate = templates.some(template =>
      !template.description || template.debit == null || template.credit == null
    );

    // Calculate totals
    const totalDebit = templates.reduce((sum, t) => sum + (parseFloat(t.debit) || 0), 0);
    const totalCredit = templates.reduce((sum, t) => sum + (parseFloat(t.credit) || 0), 0);
    const isBalanced = totalDebit === totalCredit;

    // Check required fields
    const hasRequiredFields =
      journalEntryDate && journalEntryDate !== '' &&
      journalEntryDescription && journalEntryDescription.trim() !== '';

    // Disable if there's any invalid template or not balanced or missing required fields
    return hasInvalidTemplate || !isBalanced || !hasRequiredFields;
  };


  parseNumber = (string) => {
    return parseFloat(string?.toString().replaceAll(',',''))
  }

  formatDollar = (amount, forceTwoDecimals) => {
    if(!amount) return
    let value
    if (forceTwoDecimals) {
      value = this.parseNumber(amount).toFixed(2)
    } else {
      amount = String(amount);
      if (amount.match(/.*\.\d{2}.*/)) {
        try {
          value = this.parseNumber(amount).toFixed(2)
        } catch {
          value = amount.replaceAll(',','')
        }
      } else {
        value = amount.replaceAll(',','')
      }
    }

    return value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  handleDateChange = (date) => {
    if (date) {
      this.setState({ journalEntryDate: date });
    } else {
      // Handle invalid date (e.g., cleared date)
      this.setState({ journalEntryDate: null });
    }
  };


  handleNotesChange = (note) => {
    this.setState({notes: note});
  };

    handleDescriptionChange = (description) => {
        this.setState({journalEntryDescription: description});
    };

    handleTemplateChange = (event, index, template) => {
        const { name, value } = event.target;
        const templates = [...this.state.templates];

        if (name === 'ledger') {
          if(template.journalEntryId && template.ledger){
            this.props.deleteJournalEntryFromLedger({ledger: template.ledger, journalEntryId: template.journalEntryId})
          }


          templates[index] = {
            ...template,
            ledger: value,
          };
        } else {
            templates[index] = {
                ...template,
                [name]: value,
            };
        }

        this.setState({ templates });
    };

    removeTemplateRow = (index) => {
        this.setState(prevState => {
            const updatedTemplates = prevState.templates.filter((_, curIndex) => curIndex !== index);
            return {templates: updatedTemplates};
        });
    };

    addTemplateRow = () => {
        this.setState(prevState => {
            const updatedTemplates = [...prevState.templates, {
                description: "",
                ledger: "",
                debit: "0.00",
                credit: "0.00",
            },
              {
                description: "",
                ledger: "",
                debit: "0.00",
                credit: "0.00",
              }
            ];
            return {templates: updatedTemplates};
        });
    };


  handleBlur = (e, index) => {
    let {name, value} = e.target;
    const amountFormat = isNaN(parseFloat(value)) ? "0.00" : this.formatDollar(value, true)

    this.setState(prevState => {
      const updatedTemplates = [...prevState.templates];
      updatedTemplates[index] = {
        ...updatedTemplates[index],
        [name]: amountFormat,
      };
      return {templates: updatedTemplates};
    });
  }

    render() {
      const {totalDebit, totalCredit} = this.state;

      const difference = parseFloat((totalDebit - totalCredit).toFixed(2));
      const isBalanced = difference === 0;

        return (
          <React.Fragment>
            <TopToolbar
              pageName={JOURNAL_ENTRY}
              menuItems={this.getContextualMenuItems()}
            />
            <div
              className="rowSpecSuppliers"
              style={{
                marginTop: '24px',
                marginBottom: '16px',
                marginLeft: '24px',
                marginRight: '24px',
              }}
            >

                <FormControl variant="outlined" style={{width:'250px'}}>
                  <InputLabel id="year-label">Year</InputLabel>
                  <Select
                    labelId="year-label"
                    value={this.props.selectedYear}
                    onChange={this.props.handleYearChange}
                    label="Year"
                  >
                    {this.props.years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" style={{width:'250px',marginLeft:'16px',marginRight:'16px'}}>
                  <InputLabel id="year-label">Currency</InputLabel>
                  <Select
                    labelId="currency-label"
                    value={this.props.selectedCurrency}
                    onChange={this.props.handleCurrencyChange}
                    label="Currency"
                  >
                    {this.props.currency.map((currency) => (
                      <MenuItem key={currency} value={currency}>
                        {currency}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

            </div>

            <div
              className="rowSpecSuppliers"
              style={{
                marginTop: '24px',
                marginBottom: '16px',
                marginLeft: '24px',
                marginRight: '24px',
              }}>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <KeyboardDatePicker
                                    name="date"
                                    label="Date"
                                    value={this.state.journalEntryDate}
                                    onChange={(date) => {
                                        if (!date || isNaN(date.getTime())) {
                                            return;
                                        }

                                        const options = {
                                            timeZone: 'UTC',
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: false,
                                        };
                                        const formatter = new Intl.DateTimeFormat(
                                          'en-CA',
                                          options
                                        );
                                        const parts = formatter.formatToParts(date);
                                        const formattedDate = `${
                                          parts.find((p) => p.type === 'year').value
                                        }-${parts.find((p) => p.type === 'month').value}-${
                                          parts.find((p) => p.type === 'day').value
                                        }T${parts.find((p) => p.type === 'hour').value}:${
                                          parts.find((p) => p.type === 'minute').value
                                        }:${
                                          parts.find((p) => p.type === 'second').value
                                        }.000Z`;

                                       this.handleDateChange(formattedDate)
                                    }}
                                    format="yyyy-MM-dd"
                                    variant="inline"
                                    inputVariant="outlined"
                                    style={{ width: '250px', marginRight: '16px' }}
                                    autoOk
                                    error={!this.state.journalEntryDate}
                                    required
                                  />
              </MuiPickersUtilsProvider>


              <TextField
                variant="outlined"
                name="description"
                label="Journal Entry Description"
                style={{ width: '250px' }}
                InputLabelProps={{ shrink: true }}
                value={this.state.journalEntryDescription || ''}
                onChange={(e) => this.handleDescriptionChange(e.target.value)}
                required
                error={!this.state.journalEntryDescription}
              />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                marginTop: '16px',
                marginLeft: '24px',
                marginRight: '24px',
              }}
            >
              <div className="transaction-form-section">
                {this.state.templates.map((template, index) => (
                  <div
                    className="transaction-form-details"
                    key={index}
                    draggable
                    onDragStart={() => this.onDragStart(index)}
                    onDragOver={() => this.onDragOver(index)}
                    onDragEnd={this.onDragEnd}
                    style={{
                      marginTop:'20px',
                      background:
                        this.state.draggedIndex === index ? '#f0f0f0' : 'white',
                    }}
                  >
                    <div style={{ width: '60px', display: 'flex' }}>
                      <Tooltip title={'Remove Entry'}>
                        <IconButton
                          onClick={() => {
                            const deletedEntry = [...this.state.deletedEntry, template]
                            this.setState({ deletedEntry })
                            this.removeTemplateRow(index)

                          }
                          }
                        >
                          <RemoveCircleIcon fontSize="small" color="error" />
                        </IconButton>
                      </Tooltip>

                      <div className="ledger-circle-icon">J</div>

                    </div>

                    <TextField
                      variant="outlined"
                      name="description"
                      label="Ledger Entry Description"
                      style={{ width: '250px' }}
                      InputLabelProps={{ shrink: true }}
                      value={template.description || ''}
                      onChange={(e) =>
                        this.handleTemplateChange(
                          {
                            target: {
                              name: 'description',
                              value: e.target.value,
                            },
                          },
                          index,
                          template
                        )
                      }
                      required
                      error={!template.description}
                    />

                    <Autocomplete
                      options={this.props.allLedgers}
                      getOptionLabel={(option) => `${option.name}`}
                      value={template.ledger || null}
                      onChange={(event, newValue) => {
                        this.handleTemplateChange(
                          {
                            target: {
                              name: 'ledger',
                              value: newValue,
                            },
                          },
                          index,
                          template
                        )
                      }

                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="ledger"
                          label="Ledger"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      style={{ width: '250px' }}
                    />

                    <TextField
                      variant="outlined"
                      name="debit"
                      label="Debit"
                      style={{ width: '180px' }}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                        inputProps: { style: { textAlign: 'right' } },
                      }}
                      value={this.formatDollar(template.debit)}
                      onChange={(e) =>
                        this.handleTemplateChange(
                          {
                            target: {
                              name: 'debit',
                              value: this.formatDollar(e.target.value),
                            },
                          },
                          index,
                          template
                        )
                      }
                      onBlur={(e) => this.handleBlur(e, index)}
                      required
                      error={!template.debit}
                    />

                    <TextField
                      variant="outlined"
                      name="credit"
                      label="Credit"
                      style={{ width: '180px' }}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                        inputProps: { style: { textAlign: 'right' } },
                      }}
                      value={this.formatDollar(template.credit)}
                      onChange={(e) =>
                        this.handleTemplateChange(
                          {
                            target: {
                              name: 'credit',
                              value: this.formatDollar(e.target.value),
                            },
                          },
                          index,
                          template
                        )
                      }
                      onBlur={(e) => this.handleBlur(e, index)}
                      required
                      error={!template.credit}
                    />

                    <MenuIcon
                      style={{
                        cursor: 'grab',
                        marginLeft: '8px',
                        opacity: '0.6',
                        alignSelf: 'center',
                      }}
                    />
                  </div>
                ))}
                <div style={{ marginTop: '30px',paddingBottom:'16px' }}>
                  <IconButton onClick={() => this.addTemplateRow()}>
                    <AddCircleIcon fontSize="small" color="secondary" />
                  </IconButton>
                </div>


                {this.state.templates.length > 0 && (
                    <>

                      <Divider className='section-divider' style={{marginLeft: "10px"}} />
                      <div className="rowSpecSuppliers" style={{marginLeft: "10px", marginRight:'16px'}}>
                        {/*Notes*/}
                        <div
                          style={{
                            width: '72%',
                            // backgroundColor: '#f4faff',
                            // borderRadius: '12px',
                            padding: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'left',
                            // boxShadow: '0 0 10px rgba(0,0,0,0.05)',
                            margin: '20px 20px 20px 0px',
                            fontFamily: 'sans-serif',
                          }}
                        >
                          <div>
                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>
                                <TextField
                                  label="Notes"
                                  multiline
                                  maxRows={5}
                                  InputLabelProps={{ shrink: true }}
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                  minRows={5}
                                  name="notes"
                                  value={this.state.notes}
                                  onChange={(e) => this.handleNotesChange(e.target.value)}
                                />
                              </div>

                            </div>


                          </div>


                        </div>


                        {/*totalRow*/}

                        <div
                          style={{
                            backgroundColor: '#f4faff',
                            borderRadius: '12px',
                            padding: '20px 30px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            boxShadow: '0 0 10px rgba(0,0,0,0.05)',
                            width: 'fit-content',
                            margin: '20px 0 20px auto',
                            fontFamily: 'sans-serif',
                          }}
                        >
                          <div
                            style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
                          >
                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: '14px', color: '#555' }}>
                                Total debits
                              </div>
                              <div style={{ fontWeight: 'bold', fontSize: '20px' }}>
                                ${totalDebit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </div>
                            </div>

                            <div style={{ fontSize: '24px', color: '#555', marginTop: '20px' }}>
                              {isBalanced ? '=' : '≠'}
                            </div>

                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: '14px', color: '#555' }}>
                                Total credits
                              </div>
                              <div style={{ fontWeight: 'bold', fontSize: '20px' }}>
                                ${totalCredit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </div>
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ textAlign: 'left' }}>
                              <div style={{ fontSize: '14px', color: '#555' }}>
                                {' '}
                              </div>
                              <div style={{ fontSize: '14px', color: '#555' }}>
                                Difference:
                              </div>
                            </div>

                            <div style={{ fontSize: '24px', color: '#555' }} />

                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: '14px', color: '#555' }}>

                              </div>
                              <div style={{ fontWeight: 'bold', fontSize: '20px' }}>
                                <div
                                  style={{
                                    fontWeight: 'bold',
                                    color: isBalanced ? '#00aa66' : '#e63946',
                                  }}
                                >
                                  ${Math.abs(difference).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>


                      </div>

                    </>)
                }
                </div>



                  </div>

                  </React.Fragment>
                  );
                }
}

export default EditJournalEntry;

